export const IconWtts = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7461 2.375C33.8781 2.375 42.9023 11.3993 42.9023 22.5312C42.9023 33.6633 33.8781 42.6875 22.7461 42.6875C19.2603 42.6875 15.9776 41.8016 13.1149 40.2416L4.22849 41.7307C3.78406 41.8051 3.33084 41.6621 3.00967 41.3459C2.68848 41.0298 2.53827 40.5791 2.60568 40.1334L4.1063 30.2144C3.12862 27.8448 2.58986 25.2493 2.58986 22.5312C2.58986 11.3993 11.6141 2.375 22.7461 2.375ZM15.1394 12.5941C13.7606 12.5941 12.6192 13.7573 12.8343 15.1924C13.238 17.8848 14.4351 22.8455 17.9936 26.4311C21.7137 30.1792 27.0353 31.7831 29.9196 32.4153C31.4106 32.7423 32.6836 31.5609 32.6836 30.1038V26.6846C32.6836 26.4517 32.5401 26.243 32.3228 26.1594L28.6476 24.7484C28.549 24.7106 28.4418 24.7012 28.3381 24.7214L24.6301 25.4454C22.2406 24.2075 20.7923 22.8185 19.9227 20.7288L20.6217 16.9506C20.6403 16.8504 20.6313 16.747 20.5956 16.6515L19.2177 12.9599C19.1356 12.7399 18.9255 12.5941 18.6907 12.5941H15.1394Z"
        fill="white"
      />
    </svg>
  );
};
